import { urlCombiner } from './helpers/utis';

const config = {
  AES_SECRET_KEY: 'vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3',
  AES_IV_KEY: '350c169b13cf9a1646a528be7f85f41e',
  algorithm: 'aes-256-ctr'
};

const configBasedOnEnv = {
  baseUrl: urlCombiner(process.env.REACT_APP_BASE_URL),
  api: {
    baseUrl: urlCombiner(process.env.REACT_APP_API_BASE_URL),
    adminBaseUrl: urlCombiner(process.env.REACT_APP_API_BASE_URL_AL_ADMIN),
    manageCadUrl: urlCombiner(process.env.REACT_APP_MANAGE_CAD_API_BASE_URL),
    manageCadUrlV2: urlCombiner(
      process.env.REACT_APP_MANAGE_CAD_API_BASE_URLV2
    ),
    kycMicroservicesUrlV2: urlCombiner(
      process.env.REACT_APP_KYC_MICROSERICES_V2
    ),
    testAgfinKyc: urlCombiner(process.env.REACT_APP_TEST_AGFIN_KYC),
    lms: urlCombiner(process.env.REACT_APP_SAM_LMS),
    insurance: urlCombiner(process.env.REACT_APP_API_GATEWAY_BASE_URL),
    API_GATEWAY: urlCombiner(process.env.REACT_APP_API_GATEWAY_BASE_URL_V1)
  },
  ...config
};

export default configBasedOnEnv;
